import * as d3 from 'd3'
export default {
  methods: {

    table_Viewer(selection) {

      let stg = this.winProps.stg
      let mode = this.winProps.mode
      let dataList = this.db_Table.filter(f=> f.IDX == stg.IDX && f.STG_NO==stg.STG_NO && f.RELATION==mode)
      
      let y_ = dataList.length * 80
      this.CRT = {id: -1, count: -1, mode: this.winProps.mode}

      let tblForm = selection
      .append('g')
      .attr('transform', `translate(0, 0)`)

      tblForm
      .append('text')
      .attr('x', 20).attr('y', 28).attr('fill', '#000').attr('font-size', 17).attr('font-style', 'italic')
      .text('Input Forms')

      tblForm.append('text').attr('x', 200).attr('y', 15).attr('fill', '#757575').attr('font-size', 10).attr('font-style', 'italic').attr('text-anchor', 'middle').text('ID')
      tblForm.append('text').attr('id', `CRT_ID`).attr('x', 200).attr('y', 31).attr('fill', '#000').attr('font-size', 15).attr('text-anchor', 'middle').text(0)

      tblForm.append('text').attr('x', 250).attr('y', 15).attr('fill', '#757575').attr('font-size', 10).attr('font-style', 'italic').attr('text-anchor', 'middle').text('Count')
      tblForm.append('text').attr('id', `CRT_COUNT`).attr('x', 250).attr('y', 31).attr('fill', '#000').attr('font-size', 15).attr('text-anchor', 'middle').text(0)
      tblForm.append('text').attr('id', `CRT_MODE`).attr('x', 300).attr('y', 31).attr('fill', '#000').attr('font-size', 15).attr('text-anchor', 'middle').text(0)

      tblForm
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/img/PROJECT_${this.config.project}.png`)
      .attr('x', 30).attr('y', 55).attr('width', 167)

      tblForm
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Add.svg`)
      .attr('x', mode == 'Input' && stg.STG_NO == 0 ? 160 : 35).attr('y', 120).attr('width', 20).attr('cursor', 'pointer')
      .on('mouseover', function() { d3.select(this).transition().duration(75).style('opacity', .4) })
      .on('mouseout',  function() { d3.select(this).transition().duration(250).style('opacity', 1) })
      .on('click', () => {
        
        if(this.CRT.count > 6) return

        let type = (mode=='Input' && stg.STG_NO == 1) ? 'Excel' : '' // In the case of input
        if(mode=='Exec') type = 'Procedure'
        let newData = {
          SEQ: this.CRT.id + 1,
          DIAGRAM: this.config.diagram,
          STG_NO: stg.STG_NO,
          STAGE: stg.NAME,
          TYPE: type,
          RELATION: mode,
          DATABASE: '',
          SCHEMA: '',
          NAME: '',
          FILE_PATH: '',
          EXCEL_SHEET: '',
        }
        this.tbl_Router(d3.select(`#DATA_LIST`), type, newData)

        this.reflash(this.CRT) // #####
        y_ += 80

        d3.select(`#DROPDOWN_TYPE`).moveToFront()
      })

      this.gmx_Line(tblForm, 30, 880, 150, 150, '#E0E0DF', .5, 1)

      // Get From Output -------------------------------------------------
      if(this.CRT.mode == 'Input' && stg.STG_NO > 1) {
        
        tblForm 
        .append('image')
        .attr('xlink:href', this.HOST + `/Database/btn/GetFromOutput.svg`).attr('x', 70).attr('y', 118.5).attr('width', 95)
        .attr('cursor', 'pointer')
        .on('mouseover', function() {
          d3.select(this).transition().duration(75).style('opacity', .5)
        })
        .on('mouseout', function() {
          d3.select(this).transition().duration(250).style('opacity', 1)
        })
        .on('click', () => {

          let lastData = []
          if(this.CRT.mode == 'Input' && stg.STG_NO > 0) lastData = this.db_Table.filter(f=> f.DIAGRAM == stg.DIAGRAM && f.STG_NO==stg.STG_NO-1 && f.RELATION=='Output')
          lastData.forEach(d=> {d.STG_NO = stg.STG_NO-1})

          this.CRT = {id: -1, count: -1, mode: this.winProps.mode}
          for(let i=0; i<10; i++) {
            d3.select(`#LIST_${i}`).remove()
          }

          this.draw_dataList(tblForm, lastData)
          this.reflash(this.CRT) // #####
        })

      }


      // Button Save
      tblForm 
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/btn/Save.svg`).attr('x', 705).attr('y', 110).attr('width', 80)
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).style('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).style('opacity', 1)
      })
      .on('click', () => {
        this.verify_dataList(tblForm, stg) // -----> APIs.js
      })

      // Button Close
      tblForm
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/btn/Close.svg`).attr('x', 800).attr('y', 110).attr('width', 80)
      .call(this.call_WinClosed)

      this.draw_dataList(tblForm, dataList)

    },


    draw_dataList(selection, dataList) {
      let y_ = 0
      let tblForm = selection
      .append('g')
      .attr('id', 'DATA_LIST')
      .attr('transform', `translate(0, 160)`)

      dataList.forEach((d,i)=> { 
        this.tbl_Router(tblForm, d.TYPE, d)

        for (const key in d) {
          d3.select(`#FORM_${key}_${d.SEQ}`).text(d[key])
        }
        y_ += 80
      })
      d3.select(`#DROPDOWN_TYPE`).moveToFront()
    },



    

  }
}